import { globalStyles } from "shared/constants";
const { display, flex } = globalStyles;

const aboutStyles = {
  dialogContent: {
    height: "264px",
    width: "560px",
  },
  group: {
    padding: "16px",
    ...display.flex,
    ...flex.justify.between,
    ...flex.align.center,
  },
  aboutHeading: {
    backgroundColor: "grey.100",
    ...display.flex,
    ...flex.align.center,
    ...flex.justify.between,
  },
  copyrightlabel: {
    color: 'grey.600',
    fontSize: 11,
  },
  divider: {
    position: 'absolute',
    left: 0,
    right: 0,
    backgroundColor: 'grey.400'
  }
};

export default aboutStyles;
